import AsyncStorage from '@react-native-async-storage/async-storage';
import { clientConfigPath } from '../../config/Constant';
import {
  guestBillDetailsFailure,
  guestBillDetailsRequest,
  guestBillDetailsSuccess,
} from '../Reducers/viewBillReducer';
import { setInitAppLogout } from '../Reducers/appConfigReducer';

// guestHistory API
export const guestHistory = (reservationNumber,locationId, guestBillIntervalTime) => {
  return async dispatch => {
    try {

      let guestToken = await AsyncStorage.getItem('guestToken');
      // let reservationNumber = await AsyncStorage.getItem('reservationNumber');

      const response = await clientConfigPath.post('/guestHistory/fetch', {
        header: {
          locationId: locationId,
          guestToken: guestToken,
          loggedinGuestToken: guestToken,
          reservationNumber: reservationNumber,
        },
        payload: {},
      });
      console.log('response from guest history', response.data, guestBillIntervalTime);
      if (response.status === 200) {
        if(!guestBillIntervalTime){
          await dispatch(guestBillDetails(reservationNumber,locationId))
        }else{
          const intervalTime = Number(guestBillIntervalTime) * 1000;

          await new Promise(resolve => setTimeout(resolve, intervalTime));

          try {
            await dispatch(fetchBillDetailsWithRetry(reservationNumber, locationId));
            return Promise.resolve({ status: true });
          } catch (error) {
            return Promise.resolve({ status: false, response: error });
          }
        }
        // return Promise.resolve(); // Resolve on success

      } else {

        return Promise.reject('Failed to fetch guest history');
      }

    } catch (error) {

      return Promise.reject('API guestHistory Failed');
    }
  };
};

export const fetchBillDetailsWithRetry = (reservationNumber, locationId, maxRetries = 10) => {
  return async dispatch => {
    let retryCount = 0;
    while (retryCount <= maxRetries) {
      try {
        const response = await dispatch(guestBillDetails(reservationNumber, locationId));
        if(response?.header?.status?.code != "SUCCESS" || (response?.payload && Object.keys(response?.payload)?.length == 0)){
          throw new Error(response?.header?.status?.msg || 'Bill not fetched');
        }
        return Promise.resolve(true);
      } catch (error) {
        retryCount++;
        if (retryCount <= maxRetries) {
          console.log(`Retry attempt ${retryCount}`);
        } else {
          console.log('Maximum retry attempts reached');
          return Promise.reject(error?.message || 'Failed to fetch bill details');
        }
      }
    }
  }
};



// export const guestBillDetails = ( callbackBillDetails) => {
//   console.log("ABC --- selectedGuest");

//   return dispatch => {
//     dispatch(guestBillDetailsRequest());
//       try {
//         clientConfigPath.post(
//               "/guestBillDetails/fetch",
//               {
//                   header:
//                   {
//                       locationId: selectedGuest.location,
//                       guestToken: selectedGuest.guestToken,
//                       reservationNumber: selectedGuest.reservationNumber
//                   },
//                   payload: {}
//               }
//           )
//               .then((res) => {
//                   console.log("ABC --- guestBillDetails", res);
//                   if(res.data.payload.XC){
//                       console.log('found XC value')
//                       callbackBillDetails(res.data.payload.XC.Status, true, res.data.payload.XC.msg);
//                   } else {
//                       console.log('does not found XC value')
//                       callbackBillDetails('', true);
//                   }
//                   if (res.data && res.data.payload && res.data.payload.billItems &&
//                       res.data.payload.billItems.length > 0 &&
//                       res.data.payload.billTotal && res.data.payload.billTotal.balanceAmount) {
//                           console.log('View Bill give response')
//                       dispatch({
//                           type: 'View_Bill_Details',
//                           payload: {
//                               billItems: res.data.payload.billItems,
//                               billTotal: res.data.payload.billTotal.balanceAmount,
//                               billForGuest: true
//                           }
//                       })

//                   } else {
//                       console.log("payload is empty");
//                       dispatch({
//                           type: 'View_Bill_Details',
//                           payload: {
//                               billItems: [],
//                               billTotal: null,
//                               billForGuest: true
//                           }
//                       })
//                   }
//               })
//               .catch((res) => {
//                   // if(res.status == 401){
//                   //     wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
//                   // }
//                   console.log('Error in viewbill response', res)
//                   if(res.response && res.response.data && res.response.data.header && res.response.data.header.status){
//                       callbackBillDetails('', false, res.response.data.header.status.msg);
//                   } else {
//                       callbackBillDetails('', false);
//                   }

//                   console.log("guestBillDetails/fetch Api fail with status:", res)
//                   // if(window.FireBasePlugin){
//                   //     window.FirebasePlugin.logError("guestBillDetails/fetch Api fail with status: " + res)
//                   //   }
//               })
//       } catch (e) {
//           console.log("error in Code.");
//           callbackBillDetails('', false);
//           // if(window.FireBasePlugin){
//           //     window.FirebasePlugin.logError("guestBillDetails/fetch : " + e)
//           //   }
//       }
//   }
// }

// guestBillDetails API
export const guestBillDetails = (reservationNumber,locationId) => {
  return async dispatch => {
    dispatch(guestBillDetailsRequest());
    try {

      let guestToken = await AsyncStorage.getItem('guestToken');
      // let reservationNumber = await AsyncStorage.getItem('reservationNumber');

      const response = await clientConfigPath.post('guestBillDetails/fetch', {
        header: {
          guestToken: guestToken,
          locationId: locationId,
          reservationNumber: reservationNumber,
        },
        payload: {},
      });
      dispatch(guestBillDetailsSuccess(response.data));
      return Promise.resolve(response.data);
    } catch (error) {
      console.log('error', error);

      dispatch(guestBillDetailsFailure(error.message));

      return Promise.reject('API guestBillDetails Failed');
    }
  };
};




// Send Email API
export const sendGuestMail = (emailId, locationId) => {
  return async dispatch => {
    let guestToken = await AsyncStorage.getItem('guestToken');
    clientConfigPath.post(
      `/guestProfile/updateByLocationAndGuestToken`,
      {
        header: {
          guestToken: guestToken,
          locationId: locationId,
      },
      "payload": {
        "emailId": emailId
      }
      }
    ).then((res) => {
      console.log("sendGuestMail success.", res);
    }).catch((response) => {
        console.log("send Guest Mail Api failed:", response);
    })
  }
}



export const checkOut = (selectedGuest, total, onSuccess, onFailure) => {
  return dispatch => {
      try {
        clientConfigPath.post(
              "/sendCheckOut/send",
              {
                  "header": {
                      "locationId": selectedGuest.location,
                      "guestToken": selectedGuest.guestToken,
                      "loggedinGuestToken": selectedGuest.guestToken,
                      "reservationNumber": selectedGuest.reservationNumber,
                      "balanceAmount": total
                  },
                  "payload": {}
              }
          ).then((res) => {
              console.log("extend stay res", res.data);
              if (res.data.header.status.code === "SUCCESS") {
                  onSuccess("Successfully requested your checkOut.");
              } else if (res.data.header.status.code === "FAILED") {
                  onFailure(res.data.header.status.msg || "");
              }
          })
              .catch((response = {}) => {
                  console.log("extend stay API fail", response.status);
                  if(response.status == 401){
                      dispatch(setInitAppLogout(true));
                  }

                  if(response.response && response.response.data && response.response.data.header && response.response.data.header.status){
                      onFailure(response.response.data.header.status.msg);
                  } else {
                      onFailure("");
                  }
              })
      } catch (e) {
          console.log("error in extend stay API", e);
          onFailure("");
          // if(window.FireBasePlugin){
          //     // window.FirebasePlugin.logMessage("deviceConfig API failed using faceBasedJson() face data = " + faceData + "response = " + response);
          //     window.FirebasePlugin.logError("Checkout Api failed with the status code: " + e)
          //   }
      }
  }
}